<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ $t('login.title') }}</v-toolbar-title>
            <div class="flex-grow-1" />
          </v-toolbar>
          <v-progress-linear
            v-show="loading"
            :active="loading"
            color="primary"
            :indeterminate="true"
            class="ma-0 pt-1"
            height="3"
          />
          <v-card-text>
            <v-form>
              <v-text-field
                autofocus
                v-model="email"
                :label="$i18n.t('login.email')"
                prepend-icon="mdi-account"
                type="text"
                @keyup.enter="logIn"
              />

              <v-text-field
                v-model="password"
                :label="$i18n.t('login.password')"
                prepend-icon="mdi-lock-open"
                type="password"
                @keyup.enter="logIn"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1" />
            <v-btn color="primary" @click="logIn">{{ $t('login.login') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: '',
    password: '',
    loading: false
  }),
  methods: {
    logIn() {
      const auth = {
        email: this.email,
        password: this.password
      };
      this.loading = true;
      this.$store
        .dispatch('logIn', auth)
        .then(() => {
          this.$store.dispatch('isAdmin').then(() => {
            this.loading = false;
            this.$root.$emit('showSnackbar', this.$i18n.t('login.success'));
            this.$router.push({ name: 'dashboard' });
          });
        })
        .catch(() => {
          this.loading = false;
          this.$root.$emit('showSnackbar', this.$i18n.t('login.fail'));
        });
    }
  }
};
</script>
